import { applyReducers } from 'redux/helpers';
import * as actions from './actions';
import statusFlow from './statusFlow/reducer';


export default (previosState = {}, action) => {
  const state = applyReducers({ statusFlow }, previosState, action);

  switch (action.type) {
    case actions.SET_ITEM.END:
      return {
        ...state,
        ...action.selectedItem,
      };
    case actions.SET_NAME:
      return {
        ...state,
        value: {
          ...state.value,
          name: action.name,
        },
      };
    case actions.SET_IS_ACTIVE:
      return {
        ...state,
        value: {
          ...state.value,
          isActive: action.value,
        },
      };
      case actions.SET_ITEM_COLOR:
        return {
          ...state,
          value: {
            ...state.value,
            itemColor: action.value,
          },
        };
    case actions.SET_CONTAINER_FOR:
      return {
        ...state,
        containerFor: action.options,
        value: {
          ...state.value,
          containerFor: action.options.map(x => x.id),
        },
      };
      case actions.SET_REMOVED:
        return {
          ...state,
          value: {
            ...state.value,
            isRemoved: action.value,
          },
        };
    case actions.SELECT_ITEMTYPE.END:
      return {
        ...state,
        curentOptions: action.item.curentOptions,
        containerFor: action.item.containerFor,
        type: action.item.type,
        hasContainer: action.item.hasContainer,
        value: {
          ...state.value,
          containerFor: action.item.containerFor.map(x => x.id),
          containerType: action.item.containerType,
        },
      };

    case actions.SET_CONTAINER_TYPE.BEGIN:
      return {
        ...state,
        value: {
          ...state.value,
          containerType: action.containerType,
        },
      };
    case actions.SET_CONTAINER_TYPE.END:
      return {
        ...state,
        curentOptions: action.curentOptions,
        containerFor: action.curentOptions,
        value: {
          ...state.value,
          containerFor: action.curentOptions.map(x => x.id),
        },
      };
    case actions.INVALIDATE_CHANGES:
      return {
        ...state,
        changes: action.changes,
      };
    case actions.CHECK_VALIDATION.END:
      return {
        ...state,
        errors: action.errors,
      };
    case actions.statusFlow.SET_STATUSES.BEGIN:
      return {
        ...state,
        value: {
          ...state.value,
          statuses: [...action.statuses],
        },
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        ...action.item,
        changes: 0,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/currentItem/reducer.js